import getPlaybookCardData from './getPlaybookCardData';

export default function getSubscribeBlockData(props) {
  const {
    fields: { subscribeBlock, subscribeBlockPlaybookCard },
  } = props;

  const data = {};

  if (subscribeBlock) {
    data.buttons = [];
    data.title = subscribeBlock?.fields.title ? subscribeBlock.fields.title : false;

    if (subscribeBlock?.fields?.subscribeButtonLabel) {
      const subscribeButton = {};
      subscribeButton.label = subscribeBlock?.fields?.subscribeButtonLabel;
      subscribeButton.modifier = 'Button--electricPurpleFill';
      subscribeButton.opensModal = true;
      data.buttons.push(subscribeButton);
    }

    if (subscribeBlock?.fields?.submitButtonLabel) {
      const submitButton = {};
      submitButton.label = subscribeBlock?.fields?.submitButtonLabel;
      submitButton.modifier = 'Button--semiBlack';
      submitButton.icon = 'arrow-next';
      submitButton.url = process.env.TYPEFORM_URL;
      submitButton.target = '_blank';
      data.buttons.push(submitButton);
    }
  }

  if (subscribeBlockPlaybookCard && subscribeBlock) {
    data.card = getPlaybookCardData(subscribeBlockPlaybookCard);
  }

  return Object.keys(data).length ? data : false;
}
